var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"offset-y":"","nudge-bottom":5},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),Object.assign({}, menu)),[_vm._v(" "+_vm._s(_vm.value)+" ")])]}}])},[_c('v-date-picker',{attrs:{"value":_vm.value,"allowed-dates":_vm.allowedDates},on:{"input":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }